import React from "react";
import BlogCard from "./BlogCard";
import Pagination from "./Pagination";

interface BlogGridProps {
  currentBlogs: any[];
  totalBlogs: number;
  blogsPerPage: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  searchTerm: string;
}

const BlogGrid: React.FC<BlogGridProps> = ({
  currentBlogs,
  totalBlogs,
  blogsPerPage,
  currentPage,
  onPageChange,
  searchTerm,
}) => {
  const totalPages = Math.ceil(totalBlogs / blogsPerPage);

  if (currentBlogs.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-6xl mb-4">🔍</div>
        <h3 className="text-2xl font-bold text-white mb-2">
          No articles found
        </h3>
        <p className="text-white/70">
          {searchTerm
            ? `No articles match "${searchTerm}". Try a different search term.`
            : "No blog articles available at the moment."}
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
        {currentBlogs.map((blog, index) => (
          <BlogCard key={blog.sk || `${blog.pk}-${index}`} blog={blog} />
        ))}
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </>
  );
};

export default BlogGrid;
